import { AddCircle } from '@mui/icons-material'
import { Button, IconButton, TextField } from '@mui/material'
import './addTopic.css'
import CloseIcon from '@mui/icons-material/Close';
import { toast} from 'react-toastify';
import { useState } from 'react';
import axios from 'axios';
import Topic from './Topic'
import { API_ENDPOINT, HEADER_TOKEN } from '../../../constants/constants';
import { activeTopicArranger } from '../../../utils/util';
import TopicImgUpload from '../../img-upload/topicImgUpload';
const AddTopic = (props)=>{
    const {show, setShow, category, topics, setTopics} = props
    const [tp, setTp] = useState("")
    const [mt, setMt] = useState([])
    const [image, setImage] = useState("");
    const addTopic = ()=>{
        if(tp ===""){
            toast("Please Enter Topic", {position: 'bottom-center', autoClose: 1000})
        }else{
            axios.post(API_ENDPOINT+'sam/add-topic', {category: category, topic: tp,image:image}, HEADER_TOKEN).then(res=>{
                let d = res.data
                if(d.success){
                    toast(d.message, {autoClose: 900, position: 'bottom-center'})
                    let tps = [...topics]
                    tps.push({category: category, topic: tp,image:image, status: "Active"})
                    let ars = activeTopicArranger(tps)
                    setTopics(ars)
                    setShow(false)
                    setTp("")
                    setImage("")
                }else{
                    toast(d.message, {autoClose: 900, position: 'bottom-center'})
                }
            })
        }
    }
    const onChange = (e)=>{
        let v = e.target.value
        if(v ===""){
            setMt([])
        }else{
            let nm = [...topics]
            let nnm = nm.filter(n=>n.topic.includes(v))
            setMt(nnm)
        }
        setTp(v)
    }
    const onKeyEnter = (e)=>{
        if (e.key === "Enter") {
            addTopic()
        }
    }
    return(
        <div style={{maxWidth: '600px', margin: 'auto', position: 'relative'}}>
            <div style={{display: 'flex'}} className='add-topic-ind'>
            <TextField value={tp} onKeyDown={onKeyEnter} onChange={onChange} variant='outlined' label="Enter Topic" size='small' />
            </div>
            
            <div className='add-topic-ind' style={{display: 'flex'}}>
            <TopicImgUpload banner={image} setBanner={setImage} />
            </div>
            <div className='add-topic-ind' style={{display: 'flex'}}>
            <Button onClick={addTopic} variant='contained' startIcon={<AddCircle/>} sx={{marginLeft: '6px', alignSelf: 'center'}}>Add</Button>
            
            </div>
            <div className='mt-topics-c'>
            {
                mt.map(t=>(
                    <Topic text={t.topic} image={t.image} />
                ))
            }
            </div>
        </div>
    )
}
export default AddTopic